// ═══════════════════════════════════════════════════════════════════════════
// ventanaDeVentas — la ventana con la que se cargaron las ventas, normalizada
// ───────────────────────────────────────────────────────────────────────────
// Report djynjlXICuUF0Yl803M8: el divisor de toda tasa de los agentes de
// detección sale de `datos.ventanaVentasDias` (la ventana REAL con la que el
// loader —o la vista— trajo las órdenes), nunca de un umbral ni de un default.
// Número o `null`, nunca otra cosa: un `0` del registry («no cargues ventas»)
// no puede salir como «ventana 0d», y un string de Firestore se normaliza acá
// en vez de llegar crudo a un divisor. Una sola copia para los clasificadores
// que la consumen.
// ═══════════════════════════════════════════════════════════════════════════

/** Nombre estable con el que la falta de ventana se declara degradada en
 *  `resultado.lecturas`: es lo que lee el operador en el aviso de la corrida. */
export const FUENTE_VENTANA = 'ventana-de-ventas'

/** @returns {number|null} días (> 0) o `null` si no hay ventana conocida */
export function ventanaDeVentas(ventanaVentasDias) {
  const n = Number(ventanaVentasDias)
  return Number.isFinite(n) && n > 0 ? n : null
}

/**
 * Un total medido en la ventana de ventas, llevado a `dias` días (p. ej. las
 * unidades de la ventana como «u/30d», para compararlas con una meta o con
 * otra fuente que viene en 30 días, como las visitas). `null` sin ventana:
 * nunca se asume que la ventana ya era de `dias`.
 * @returns {number|null}
 */
export function escalarADias(valor, ventanaVentasDias, dias) {
  const v = ventanaDeVentas(ventanaVentasDias)
  return v === null ? null : (Number(valor) || 0) * dias / v
}

/**
 * El gasto de un ad (`cost`, que suma `ventanaGastoDias` días de SUS métricas, no los de
 * las ventas) llevado a un mes y a «hasta el quiebre». Una sola copia para el
 * clasificador y el dashboard (report bvwlp0MPBf2X9gx58XrL). Sin ventana, `null` en los dos.
 * @returns {{ahorroMensual: number|null, ahorroProyectado: number|null}}
 */
export function ahorroDeGastoDeAd(cost, ventanaGastoDias, diasAQuiebre) {
  return {
    ahorroMensual: escalarADias(cost, ventanaGastoDias, 30),
    ahorroProyectado: escalarADias(cost, ventanaGastoDias, diasAQuiebre),
  }
}

/** Suma que se niega a dar una cifra parcial: un solo `null` (ad sin ventana) → `null`. */
export function sumaONull(valores) {
  let total = 0
  for (const v of valores) {
    if (v === null || v === undefined) return null
    total += v
  }
  return total
}
